const LOGIN_REQUEST = "LOGIN_REQUEST";
const LOGIN_SUCCESS = "LOGIN_SUCCESS";
const LOGIN_FAILURE = "LOGIN_FAILURE";

const REGISTER_REQUEST = "REGISTER_REQUEST";
const REGISTER_SUCCESS = "REGISTER_SUCCESS";
const REGISTER_FAILURE = "REGISTER_FAILURE";

const UPDATE_PROFILE = "UPDATE_PROFILE";

const LOGOUT = "LOGOUT";

const GETCHATROOMS = "GETCHATROOMS";
const SETCURRENTCHAT = "SETCURRENTCHAT";
const SETCURRENTCHATMESSAGES = "SETCURRENTCHATMESSAGES";
export {
  LOGIN_REQUEST,
  LOGIN_SUCCESS,
  LOGIN_FAILURE,
  REGISTER_REQUEST,
  REGISTER_SUCCESS,
  REGISTER_FAILURE,
  UPDATE_PROFILE,
  LOGOUT,
  GETCHATROOMS,
  SETCURRENTCHAT,
  SETCURRENTCHATMESSAGES,
};
